import Navbar from "./modules/navbar";
import Hero from "./modules/hero";
import TypesDeBusiness from "./modules/types-de-business";
import Slider from "./modules/slider";
import FAQ from "./modules/faq";
import ToTheTop from "./modules/to-the-top";
import Benefits from "./modules/benefits";
import ScrollingText from "./modules/scrollingText";

const navbar = new Navbar();
const hero = new Hero();
const typesdebusiness = new TypesDeBusiness();
const slider = new Slider();
const faq = new FAQ();
const tothetop = new ToTheTop();
const benefitss = new Benefits();
const scrollingText = new ScrollingText();